<template>
    <div id="contact_us" style="min-height: inherit; display: flex; flex-direction: column;">
        <Header title="Contact Us" />
        <div class="mainbody">
            <div id="content">
                <h3>We'd love to hear from you!</h3>
                <div class="InstructionSection">
                    <p>Whether you have a question about your policy, pricing, or billing, or need anything else, our account management team is ready to answer all your questions.</p>
                    <ul class="InstructionList">
                        <li>Email us at: <a href="mailto:accountmanagement@omahanational.com">accountmanagement@omahanational.com</a></li>
                        <li>Call us at: <a href="tel:+18447618400">844-761-8400</a></li>
                    </ul>
                </div>
            </div>
            <CompanyInfo />
        </div>
    </div>
</template>

<script>
  import Header from "./shared/Header";
  import CompanyInfo from "./shared/CompanyInfo";

  export default {
    name: "ContactUs",
    components: { Header, CompanyInfo },

  }
</script>

<style scoped>
</style>